export const API = Object.freeze({
  VALIDATE_TOKEN: '/accesstoken/validation',
  DEVICE_CONTROL_ENDPOINT: deviceId => `/v2/hrm/devices/${deviceId}/controls`,
  //authentication api
  AUTH_ENDPOINT: '/oauth/token',
  //devices
  DEVICES_INFORMATION: deviceId => `/v2/hrm/devices/${deviceId}/information`,
  POST_DEVICE_RM_STATE: uuid => `/v2/hrm/devices/${uuid}/rmstate`,
  POST_DEVICE_RM_STATE_PINCODE_FORCED: (uuid, deviceType) =>
    `/v2/hrm/devices/rmstate/${uuid}/${deviceType}/pincode/forced`,
  GET_DEVICE_TYPE: (selectedDeviceType, pinCode) =>
    `/v2/hrm/devices/rmstate/${selectedDeviceType}/pincode/${pinCode}`,
  DEVICE_ERROR_HISTORY: devceId => `/v2/hrm/devices/${devceId}/errorhistory`,
  DEVICE_OPERATION_HISTORY: devceId =>
    `/v2/hrm/devices/${devceId}/operationhistory`,
  SAVE_DATA: '/v2/hrm/multi/devices/saveData',

  SAVE_RESULT_APIENDPOINT: svcId => `/v2/hrm/service/svcresult2/${svcId}`,
  //devices
  DEVICE_ANALYTICS_SYMPTOM: deviceId => `/v2/hrm/devices/${deviceId}/analytics`,
  DEVICE_ERROR_SYMPTOM: deviceUUID => `/v2/hrm/devices/${deviceUUID}/errors`,
  DEVICE_ANALYTICS_SUMMARY: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/analytics/summary`,
  DEVICE_ANALYTICS_FEEDBACK: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/analytics/feedback`,
  DEVICE_STATES: deviceUUID => `/v2/hrm/devices/${deviceUUID}/states`,
  DEVICE_TEMPERATURE_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/temperatures/ref`,
  DEVICE_TEMPERATURE_CONTROL_CUBE_REF: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/temperatures`,
  DEVICE_WINECELLAR_TEMPERATURE_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/temperatures`,
  DEVICE_REFRIGERATION_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/refrigeration`,
  DEVICE_SERVICE_OPTION_COOLING: (deviceUUID, option) =>
    `/v2/hrm/devices/${deviceUUID}/serviceoption/${option}`,
  DEVICE_ICEMAKER_ONE_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/icemakerOne/0`,
  DEVICE_ICEMAKER_TWO_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/icemakerTwo`,
  DEVICE_ICEMAKER_THREE_CONTROL: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/icemakerThree`,
  DEVICE_FORCE_DEFROST: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/forcedeforst`,
  DEVICE_DEFROST: deviceUUID => `/v2/hrm/devices/${deviceUUID}/deforst`,
  DEVICE_ICE_MAKER_RESET: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/icemakerreset`,
  DEVICE_NIGHT_ICE_MAKING: (deviceUUID, modeId) =>
    `/v2/hrm/devices/${deviceUUID}/mode/${modeId}`,
  DEVICE_SPECIAL_ZONE_BEVERAGE: (deviceUUID, zoneId) =>
    `/v2/hrm/devices/${deviceUUID}/specialzone/beverageZone/${zoneId}`,
  DEVICE_ICE_MAKER: deviceUUID => `/v2/hrm/devices/${deviceUUID}/icemaker`,
  DEVICE_MODE: deviceUUID => `/v2/hrm/devices/${deviceUUID}/mode`,
  DEVICE_AUTO_FILL: deviceUUID => `/v2/hrm/devices/${deviceUUID}/autofill`,
  DEVICE_FILTERS_RESET: (deviceUUID, filterId) =>
    `/v2/hrm/devices/${deviceUUID}/filtersreset/${filterId}`,
  DEVICE_DISPENSER: deviceUUID => `/v2/hrm/devices/${deviceUUID}/dispenser`,
  DEVICE_MODE_OPTIONS: deviceUUID =>
    `/v2/hrm/devices/${deviceUUID}/mode/options`,
  DEVICE_LOCK: deviceUUID => `/v2/hrm/devices/${deviceUUID}/lock`,
  UPDATE_FHUB: deviceId => `/v2/hrm/fhub/${deviceId}/update`,
  DEVICE_VACATION: deviceUUID => `/v2/hrm/devices/${deviceUUID}/vacation`,
  //Multi devices
  MULTI_DEVICES_SAVE_DATA: '/v2/hrm/multi/devices/saveData',
  MULTI_DEVICES_INFORMATION: '/v2/hrm/multi/devices/information',
  UPDATE_SVC_HISTORY: '/v2/hrm/multi/devices/updateSvcEzoneHist',

  //Service information

  //Screenshot
  SCREENSHOT_START: '/v2/hrm/screenshare/start',
  SERVICE_INFORMATION: svcId => `/v2/hrm/service/information/${svcId}`,
  SERVICE_INFORMATION_UPDATE: svcId =>
    `/v2/hrm/service/information/${svcId}/update`,
  SERVICE_INFORMATION_ENDTYPE: '/v2/hrm/service/information/endtype',

  //waitdiagnosis apis
  GET_DEVICE_LIST_USING_PINCODE: (deviceType, pincode) =>
    `/v2/hrm/devices/rmstate/${deviceType}/pincode/${pincode}`,

  // Device map history
  DEVICE_MAP_HISTORY: deviceId => `/v2/hrm/devices/${deviceId}/maphistory`,
  DEVICE_RC_DIAGNOSIS: deviceId => `/v2/hrm/devices/${deviceId}/rc-diagnosis`,
  DEVICE_SMART_RESET: deviceId => `/v2/hrm/devices/${deviceId}/reset`,
  DEVICE_WINECELLAR_DEMO_MODE: () =>
    `/api/remote-diagnosis/winecellar/demo-mode`,
  //Wahser state API Update
  STATE_UPDATE: (deviceUuid, endpoint) =>
    `/v2/hrm/devices/${deviceUuid}${endpoint}`,
});

export const WSAHER_DRYER_STATE_API_CONFIG = {
  state: '/operational/state',
  course: '/course',
  wrinklePrevent: '/wrinklePreventStatus',
  dryLevel: '/dryLevel',
  aiOption: '/aiOption',
  setting: '/setting',
  autoDetergentInput: '/autoDetergentCourse',
  autoDetergentConcentrated: '/autoDetergentCourse',
  autoSoftenerInput: '/autoSoftenerCourse',
  autoSoftenerConcentrated: '/autoSoftenerCourse',

  autoDetergentCourse: '/autoDetergentCourse',

  valve: '/washer/valve',
  pump: '/washer/pump',
  motor: '/washer/motor',
  flexState: '/operational/state/1',
  flexCourse: '/course/1',
  language: '/setting',

  // RVC specific endpoints
  robotvacuumPower: '/operation',
  robotvacuumOperation: '/mode',
  controlHoming: '/mode',
  cleaningPart: '/mode',
  repeatedCleaning: '/mode',
  turbo: '/mode',
  sound: '/voicefeedback',
  sound1: '/settings/sound/language',
  voicefeedback: '/voicefeedback',
  voicefeedback1: '/settings/sound/language',
  gender: '/sound/settings/voice/',

  //hood
  fanSpeed: '/fanspeed/',
};

export const DEVICE_WATERPURIFIER_ENDPOINT = {
  smartReset: '/reset',
  sterilize: '/sterilize',
  buzzLock: '/statusLock',
  hotwaterLock: '/statusLock',
  coldwaterLock: '/statusLock',
};

export const DISHWASHER_STATE_API_CONFIG = {};

export const STEAMCLOSET_STATE_API_CONFIG = {
  steamClosetState: '/operational/state',
  steamClosetCourse: '/course',
  steamClosetSanitize: '/sanitize',
  steamClosetSilent: '/silent',
  steamClosetKeepFresh: '/wrinklePreventStatus',
  steamClosetFilterUsage: '/courseFilterReset/0',
};

export const SHOEDRESSER_STATE_API_CONFIG = {
  shoeDresserPower: '/operation',
  shoeDresserState: '/operational/state',
  shoeDresserCourse: '/course',
  shoeDresserCleanStorage: '/cleanStorage',
};

export const HUMIDIFIER_STATE_API_CONFIG = {
  humidifierPower: '/operation',
  humidifierMode: '/mode',
  humidifierHumidity: '/humidity',
  humidifierFanSpeed: '/fanSpeed',
  humidifierTimer: '/timer',
  humidifierChildLock: '/childLock',
  humidifierWaterTank: '/waterTank',
  humidifierFilter: '/filter',
};

export const AIRCONDITIONER_STATE_API_CONFIG = {
  // Dropdown endpoints

  'mode.modes': sufix => `/mode${sufix}`,
  'temperature.desired': sufix => `/temperatures${sufix}`,
  'airflow.direction': sufix => `/airflow/direction${sufix}`,
  'airflow.speedLevel': sufix => `/airflow/speedLevel${sufix}`,
  'options.Sleep': sufix => `/mode/options${sufix}`,
  'options.Light': sufix => `/mode/options${sufix}`,
  'options.Panel': sufix => `/mode/options${sufix}`,
  'options.Blooming': sufix => `/mode${sufix}`,
  'options.Volume': sufix => `/mode${sufix}`,
  'options.OnTimer': sufix => `/mode${sufix}`,
  'options.OffTimer': sufix => `mode${sufix}`,
  'comode.comode': sufix => `/mode/convenient${sufix}`,
  'optionAutoclean.autocleanSetting': sufix => `/autoclean${sufix}`,
  'filter.filterUsage': sufix => `/filtersreset${sufix}`,
  'filters.airdustfilter': sufix => `filtersreset${sufix}`,
  'filters.airdustPM1filter': sufix => `/filtersreset${sufix}`,
  'filters.hepafilter': sufix => `/filtersreset${sufix}`,
  'options.SmartReset': sufix => `/smartreset`,

  // Radio button endpoints
  'operation.power': (_, sufix) => `/operation${sufix}`,
  'options.Autoclean': (_, sufix) => `/mode${sufix}`,
  'options.Display': (_, sufix) => `/mode${sufix}`,
  'options.Booster': (_, sufix) => `/mode${sufix}`,
  'options.ComfortAICooling': (_, sufix) => `/mode${sufix}`,
  'options.DiagnosisAI': (_, sufix) => `/mode${sufix}`,
  'options.SmartCoolClean': (_, sufix) => `/mode${sufix}`,
  'bixby.state': (_, sufix) => `/bixby${sufix}`,
  'optionAutoclean.autocleanStatus': (_, sufix) => `/autoclean${sufix}`,
  'windLong.windLong': (_, sufix) => `/windlong${sufix}`,
  'windFree.windFree': (_, sufix) => `/windfree${sufix}`,
};

export const KIMCHI_REFERIGERATOR_STATE_API_CONFIG = {
  onedoorMode: '/mode/0',
  forceDefrost: '/forcedeforst',
  smartReset: '/reset',
  ktopMode: '/mode/0',
  kmiddleMode: '/mode/0',
  kbottomMode: '/mode/0',
};
